import set from 'lodash/set';
import get from 'lodash/get';

export const lzFIsObject = (input: any) => {
    return typeof input === 'object' && input !== null;
};

export const lzFIsArray = (input: any) => {
    return Array.isArray(input);
};

export const lzFIsString = (input: any) => {
    return typeof input === 'string';
};

export const lzFArrayUnique = (arr: []) => {
    return arr.filter((value, index, self) => self.indexOf(value) === index);
};

export const lzFJsonToString = (value: any) => {
    return JSON.stringify(value);
};

export const lzFDeepVarSet = (obj: any, path: string, val: any) => {
    set(obj, path, val);
};

export const lzFDeepVarGet = (obj: any, path: string, defVal: any) => {
    return get(obj, path, defVal);
};
